import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

type uploadCustomProductsResponse = ClientInferResponseBody<
  typeof contract.products.uploadCustomProducts,
  200
>;

export const uploadCustomProducts = async (file: File): Promise<uploadCustomProductsResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.products.uploadCustomProducts.mutation({
    body: formData,
  });

  if (response.status === 200) {
    return response.body;
  }

  return { success: false };
};
